var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcShowHiddenList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "23px",
    viewBox: "0 0 40 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icShowHiddenList") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.36,0.1969375 C3.64258667,0.1969375 0.618634286,3.20370833 0.618634286,6.9 C0.618634286,10.5962917 3.64258667,13.6030625 7.36,13.6030625 C11.0774133,13.6030625 14.1013657,10.5962917 14.1013657,6.9 C14.1013657,3.20370833 11.0769314,0.1969375 7.36,0.1969375 Z M7.36,11.5105417 C4.80349524,11.5105417 2.72311238,9.44197917 2.72311238,6.9 C2.72311238,4.35802083 4.80301333,2.28945833 7.36,2.28945833 C9.91698667,2.28945833 11.9968876,4.35754167 11.9968876,6.9 C11.9968876,9.44245833 9.91650476,11.5105417 7.36,11.5105417 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3002971,9.3911875 C36.498021,6.6628125 29.0313886,0.316729167 20.24,0.316729167 C11.4481295,0.316729167 3.98149714,6.66329167 1.17970286,9.39166667 C0.603826667,9.95229167 0.286733333,10.70075 0.286733333,11.5 C0.286251429,12.29925 0.603344762,13.0481875 1.17970286,13.6092917 C3.98149714,16.3376667 11.4476476,22.6832708 20.24,22.6832708 C29.0318705,22.6832708 36.4985029,16.3371875 39.300779,13.6088125 C39.8766552,13.0477083 40.1937486,12.2987708 40.1932667,11.4995208 C40.1932667,10.70075 39.8761733,9.9518125 39.3002971,9.3911875 Z M37.8280781,12.1138125 C35.2103714,14.6625 28.2564857,20.59075 20.24,20.59075 C12.2225505,20.59075 5.26962857,14.6625 2.65240381,12.1138125 C2.48373714,11.9499375 2.39121143,11.7319167 2.39121143,11.5 C2.39121143,11.2680833 2.48373714,11.0505417 2.6519219,10.8866667 C5.26962857,8.3375 12.2230324,2.40925 20.24,2.40925 C28.2560038,2.40925 35.2103714,8.3375 37.8280781,10.8866667 C37.9962629,11.0505417 38.0887886,11.2680833 38.0887886,11.5 C38.0892705,11.7319167 37.9962629,11.9499375 37.8280781,12.1138125 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hidden-list----Options",
    transform: "translate(-308.000000, -104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/General/ViewOutline",
    transform: "translate(305.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey-copy",
    transform: "translate(15.640000, 16.560000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey",
    mask: "url(#mask-2)",
    fill: "#646464"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.640000, -16.560000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 46 0 46 46 0 46"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(2.760000, 11.960000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey",
    mask: "url(#mask-4)",
    fill: "#646464"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.760000, -11.960000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 46 0 46 46 0 46"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShowHiddenList);
export default __webpack_public_path__ + "static/media/icShowHiddenList.ddefed3ad801d7afcb8c585b52df95f5.svg";
export { ForwardRef as ReactComponent };